import { makeStyles } from 'tss-react/mui';

/**
 * Local styles for the copy button. The button's own visual treatment
 * comes from the shared `useMessageActionButtonStyles`; only the
 * screen-reader announcement node lives here.
 */
const useStyles = makeStyles()(() => ({
  // Absolute positioning keeps this node out of the surrounding flex
  // row, so it neither becomes a flex item nor opens an extra gap.
  visuallyHidden: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    border: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
